<div class="loading-frame">
    <div class="loader">LOADING...</div>
</div>